import { Directive } from '@angular/core';

@Directive({
  selector: '[app-icon]',
  host: { class: 'antialiased font-material text-2xl leading-none' },
})
export class IconDirective {}
